import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { classMap } from 'lit/directives/class-map.js'
import { customElement, property, query } from 'lit/decorators.js'
import { groupStyle, style } from './checkbox.style.js'
import { BooleanFormElement } from 'elements/_shared/formElement.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


initializeIconsByRole({
  'cse-checkbox.check': { name: 'check', style: 'light' },
})

@customElement('cse-checkbox')
export class CSECheckbox extends BooleanFormElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String, attribute: 'id' })
  _id = ''

  @property({ type: String })
  name = ''

  @property({ type: String, reflect: true })
  value = ''

  @property({ type: Boolean })
  required = false

  @property({ type: Boolean })
  disabled = false

  @property({ type: Boolean, reflect: true })
  checked = false

  @property({ type: Boolean })
  override autofocus = false

  @query('input')
  input!: HTMLInputElement

  private toggleChecked = () => {
    if (!this.disabled) {
      this.checked = !this.checked
      this.emit(this.checked)
    }
  }

  constructor() {
    super()
    this.addEventListener('click', this.toggleChecked)
  }

  override focus() {
    this.input.focus()
  }

  override render() {
    return html`
      <div
        class=${classMap({
          'cse-checkbox': true,
          'checked': this.checked,
          'disabled': this.disabled,
        })}
      >
        <input
          type="checkbox"
          id="${this._id}"
          name="${this.name}"
          value="${this.value}"
          ?required="${this.required}"
          ?disabled="${this.disabled}"
          ?checked="${this.checked}"
          ?autofocus="${this.autofocus}"
        >
        ${this.checked
          ? html`<cse-icon icon-role="cse-checkbox.check" size="xxs"></cse-icon>`
          : nothing
        }
        <label for="${this._id}" class="label">
          <slot></slot>
        </label>
      </div>
    `
  }
}

@customElement('cse-checkbox-group')
export class CSECheckboxGroup extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, groupStyle]

  override render() {
    return html`
      <div class="cse-checkbox-group">
        <slot></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-checkbox': CSECheckbox,
    'cse-checkbox-group': CSECheckboxGroup
  }
}
